import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import siteConfig from "../../data/siteConfig.json";

const reveal = {
  hidden: { opacity: 0, y: 22 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay, duration: 0.66, ease: [0.16, 1, 0.3, 1] }
  })
};

function TestimonialsHero() {
  const heroStats =
    siteConfig.statistics?.testimonials?.heroStats ?? [
      { value: "1200+", label: "Students Guided" },
      { value: "7+", label: "Destinations Supported" },
      { value: "End-to-End", label: "Admissions to Visa Support" }
    ];

  return (
    <section className="relative overflow-hidden pb-16 pt-28 md:pb-24 md:pt-36">
      <div className="absolute inset-0 bg-gradient-to-b from-indigo-900 via-purple-900/90 to-midnight-navy" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.1),transparent_40%),radial-gradient(circle_at_80%_80%,rgba(167,139,250,0.15),transparent_40%)]" />
      <div className="absolute left-0 top-0 h-[500px] w-[500px] rounded-full bg-indigo-500/10 blur-[120px]" />
      <div className="absolute right-0 bottom-0 h-64 w-64 rounded-full bg-fuchsia-500/10 blur-[100px]" />

      <div className="relative mx-auto w-full max-w-4xl px-6">
        <div className="flex flex-col items-center text-center">
          <motion.p
            custom={0.05}
            variants={reveal}
            initial="hidden"
            animate="visible"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-white shadow-sm backdrop-blur-md"
          >
            <Sparkles className="h-3.5 w-3.5 text-purple-300" aria-hidden="true" />
            Student Stories
          </motion.p>

          <motion.h1
            custom={0.12}
            variants={reveal}
            initial="hidden"
            animate="visible"
            className="mt-6 text-3xl leading-[1.1] font-bold tracking-tight text-white sm:text-4xl md:text-6xl drop-shadow-sm"
          >
            Real Journeys. Real Progress. Real Confidence.
          </motion.h1>

          <motion.p
            custom={0.2}
            variants={reveal}
            initial="hidden"
            animate="visible"
            className="mt-6 max-w-2xl text-sm leading-relaxed text-purple-100/90 sm:text-base md:text-lg"
          >
            Hear from students who planned their overseas education journey with clarity, expert guidance, and
            dependable support from NextEra Abroad.
          </motion.p>

          <motion.div
            custom={0.28}
            variants={reveal}
            initial="hidden"
            animate="visible"
            className="mt-12 flex flex-col sm:flex-row flex-wrap justify-center items-center gap-6 pt-10 border-t border-white/10 w-full"
          >
            {heroStats.map((item) => (
              <div key={item.label} className="flex flex-col items-center px-4">
                <p className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{item.value}</p>
                <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-purple-200/80">{item.label}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default TestimonialsHero;
